import { Option } from "api/types/_public";

export const METHOD_OPTIONS: Option[] = [
  {
    label: "GET",
    value: "GET",
  },
  {
    label: "POST",
    value: "POST",
  },
  {
    label: "PUT",
    value: "PUT",
  },
  {
    label: "DELETE",
    value: "DELETE",
  },
];

export const TYPE_SHOW_MORE_HASHTAG = {
  SCROLL: "scroll",
  MODAL: "modal",
};

export const ARR_INDEX_TEXT_DAY_OF_WEEK: string[] = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

// Status
export const ENUM_STATUS_ACTIVE_DISABLE = {
  ACTIVATE: 1,
  DISABLED: 2,
};

export const COLOR_STATUS_ACTIVE_DISABLE: any = {
  [ENUM_STATUS_ACTIVE_DISABLE.ACTIVATE]: "success",
  [ENUM_STATUS_ACTIVE_DISABLE.DISABLED]: "danger",
};

export const STATUS_ACTIVE_DISABLE_OPTION = [
  {
    label: "Active",
    value: ENUM_STATUS_ACTIVE_DISABLE.ACTIVATE,
  },
  {
    label: "Disable",
    value: ENUM_STATUS_ACTIVE_DISABLE.DISABLED,
  },
];

// User
export const ENUM_STATUS_USER = {
  PENDING: "pending",
  ACTIVATED: "activated",
  DISABLED: "disabled",
};

export const COLOR_STATUS_USER: any = {
  [ENUM_STATUS_USER.PENDING]: "primary",
  [ENUM_STATUS_USER.ACTIVATED]: "success",
  [ENUM_STATUS_USER.DISABLED]: "danger",
};

export const STATUS_USER_OPTION = [
  {
    label: "Pending",
    value: ENUM_STATUS_USER.PENDING,
  },
  {
    label: "Activated",
    value: ENUM_STATUS_USER.ACTIVATED,
  },
  {
    label: "Disabled",
    value: ENUM_STATUS_USER.DISABLED,
  },
];

export const LIST_OPTION_GENDER = [
  // {
  //   label: "Gender_Unknown",
  //   value: "unknown",
  // },
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Female",
    value: "FEMALE",
  },
];

export const LIST_OPTION_PLATFORM = [
  {
    label: "Platform_Google",
    value: "GOOGLE",
  },
  {
    label: "Platform_Kakao",
    value: "KAKAO",
  },
  {
    label: "Platform_Naver",
    value: "NAVER",
  },
];

export const LIST_OPTION_OS = [
  {
    label: "iOS",
    value: "ios",
  },
  {
    label: "Android",
    value: "android",
  },
  {
    label: "Windows",
    value: "windows",
  },
];

export const LIST_OPTION_ROLE = [
  {
    value: "normal",
    label: "Normal",
  },
  {
    value: "premium",
    label: "Premium",
  },
];

export const ENUM_TYPE_ADVERTISEMENT = {
  NATIVE: "native",
  VIDEO: "video",
};

export const COLOR_TYPE_ADVERTISEMENT: any = {
  [ENUM_TYPE_ADVERTISEMENT.NATIVE]: "primary",
  [ENUM_TYPE_ADVERTISEMENT.VIDEO]: "danger",
};

//notification setting
export const ENUM_NOTI_SETTING_STATUS = {
  ACTIVATED: "activated",
  DISABLED: "disabled",
};

export const NOTI_SETTING_STATUS_OPTION = [
  { label: "Activated", value: ENUM_NOTI_SETTING_STATUS.ACTIVATED },
  { label: "Disabled", value: ENUM_NOTI_SETTING_STATUS.DISABLED },
];

export const ENUM_NOTIFY_TYPE = {
  AUTO: "auto",
  MANUAL: "manual",
};

export const COLOR_NOTIFY_TYPE: any = {
  [ENUM_NOTIFY_TYPE.AUTO]: "primary",
  [ENUM_NOTIFY_TYPE.MANUAL]: "warning",
};

export const ENUM_PUSH_STATUS = {
  WAITING: "waiting",
  COMPLETED: "completed",
};

export const COLOR_PUSH_STATUS: any = {
  [ENUM_PUSH_STATUS.WAITING]: "primary",
  [ENUM_PUSH_STATUS.COMPLETED]: "success",
};

export const LIST_OPTION_PUSH_STATUS = [
  {
    value: ENUM_PUSH_STATUS.WAITING,
    label: "Waiting",
  },
  {
    value: ENUM_PUSH_STATUS.COMPLETED,
    label: "Completed",
  },
];

export const ENUM_BAR_LIST_PLAN = {
  LIST_PLAN: "List",
  BOOST_PLAN: "Boost",
};

export const COLOR_BAR_LIST_PLAN: any = {
  [ENUM_BAR_LIST_PLAN.LIST_PLAN]: "primary",
  [ENUM_BAR_LIST_PLAN.BOOST_PLAN]: "warning",
};

export const LIST_OPTION_BAR_LIST_PLAN = [
  {
    value: ENUM_BAR_LIST_PLAN.LIST_PLAN,
    label: "Plan_List",
  },
  {
    value: ENUM_BAR_LIST_PLAN.BOOST_PLAN,
    label: "Plan_Boost",
  },
];

export const ENUM_BAR_LIST_OPEN_STATUS = {
  OPEN: 1,
  CLOSED: 0,
};

export const COLOR_BAR_LIST_OPEN_STATUS: any = {
  [ENUM_BAR_LIST_OPEN_STATUS.OPEN]: "success",
  [ENUM_BAR_LIST_OPEN_STATUS.CLOSED]: "danger",
};

export const LIST_OPTION_BAR_LIST_OPEN_STATUS = [
  {
    label: "Open",
    value: ENUM_BAR_LIST_OPEN_STATUS.OPEN,
  },
  {
    label: "Closed",
    value: ENUM_BAR_LIST_OPEN_STATUS.CLOSED,
  },
];

export const COLOR_BAR_LIST_PARTNER_STATUS: any = {
  ["partnered"]: "success",
  ["general"]: "danger",
};

export const LIST_OPTION_BAR_LIST_PARTNER_STATUS = [
  {
    label: "Partner",
    value: "partnered",
  },
  {
    label: "General",
    value: "general",
  },
];

export const LIST_OPTION_BAR_LIST_RATING = [1, 2, 3, 4, 5]?.map(
  (item: any) => ({
    value: item,
    label: item,
  })
);

export const ENUM_BAR_DETAIL_STAFF_POSITION = {
  NORMAL: 1,
  BARTENDER: 2,
  MANAGER: 3,
};

export const COLOR_BAR_DETAIL_STAFF_POSITION: any = {
  [ENUM_BAR_DETAIL_STAFF_POSITION.NORMAL]: "primary",
  [ENUM_BAR_DETAIL_STAFF_POSITION.BARTENDER]: "success",
  [ENUM_BAR_DETAIL_STAFF_POSITION.MANAGER]: "warning",
};

export const LIST_OPTION_BAR_DETAIL_STAFF_POSITION = [
  {
    value: ENUM_BAR_DETAIL_STAFF_POSITION.NORMAL,
    label: "NORMAL",
  },
  {
    value: ENUM_BAR_DETAIL_STAFF_POSITION.BARTENDER,
    label: "BARTENDER",
  },
  {
    value: ENUM_BAR_DETAIL_STAFF_POSITION.MANAGER,
    label: "MANAGER",
  },
];

export const ENUM_BAR_DETAIL_REVIEW_STATUS = {
  ACTIVE: 1,
  DISABLE: 0,
};

export const COLOR_STICKER_STATUS: any = {
  [ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE]: "success",
  [ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE]: "danger",
};

export const LIST_OPTION_BAR_DETAIL_REVIEW_STATUS = [
  {
    value: ENUM_BAR_DETAIL_REVIEW_STATUS.ACTIVE,
    label: "Active",
  },
  {
    value: ENUM_BAR_DETAIL_REVIEW_STATUS.DISABLE,
    label: "Disable",
  },
];

export const ENUM_TYPE_BARTENDER = {
  SYSTEM: 1,
  BARTENDER: 2,
};

export const COLOR_TYPE_BARTENDER: any = {
  [ENUM_TYPE_BARTENDER.SYSTEM]: "success",
  [ENUM_TYPE_BARTENDER.BARTENDER]: "primary",
};

export const LIST_OPTION_TYPE_BARTENDER = [
  {
    label: "System",
    value: ENUM_TYPE_BARTENDER.SYSTEM,
  },
  {
    label: "Bartender User",
    value: ENUM_TYPE_BARTENDER.BARTENDER,
  },
];

export const ENUM_STATUS_POST = {
  ACTIVATED: 1,
  DISABLED: 0,
};

export const ENUM_STATUS_APPLICATION = {
  PENDING: 0,
  IN_REVIEW: 1,
  RESULTED: 2,
};

export const COLOR_STATUS_POST: any = {
  [ENUM_STATUS_POST.ACTIVATED]: "success",
  [ENUM_STATUS_POST.DISABLED]: "danger",
};

export const COLOR_STATUS_APPLICATION: any = {
  [ENUM_STATUS_APPLICATION.PENDING]: "warning",
  [ENUM_STATUS_APPLICATION.IN_REVIEW]: "primary",
  [ENUM_STATUS_APPLICATION.RESULTED]: "success",
};

export const STATUS_POST_OPTION = [
  {
    label: "Activated",
    value: ENUM_STATUS_POST.ACTIVATED,
  },
  {
    label: "Disabled",
    value: ENUM_STATUS_POST.DISABLED,
  },
];

export const ENUM_STICKER_PACKAGE_TYPE = {
  STANDARD: 0,
  PREMIUM: 1,
};

export const COLOR_STICKER_PACKAGE_TYPE: any = {
  [ENUM_STICKER_PACKAGE_TYPE.STANDARD]: "success",
  [ENUM_STICKER_PACKAGE_TYPE.PREMIUM]: "danger",
};

export const STICKER_PACKAGE_TYPE_OPTION = [
  {
    label: "Package Type Standard",
    value: ENUM_STICKER_PACKAGE_TYPE.STANDARD,
  },
  {
    label: "Package Type Premium",
    value: ENUM_STICKER_PACKAGE_TYPE.PREMIUM,
  },
];

//reservation
export const ENUM_BOOKING_STATUS = {
  SERVING: 1,
  WAITING: 2,
  USING: 3,
  RELEASED: 4,
  DISABLED: 5,
  CANCELLED: 6,
};

export const ENUM_AGENCY = {
  NOT_BELONG_TO_AGENCY: "0",
};

export const ENUM_CAMPAIGN = {
  NOT_BELONG_TO_CAMPAIGN: "0",
};

export const COLOR_AGENCY_OPTION: any = {
  [ENUM_AGENCY.NOT_BELONG_TO_AGENCY]: "danger",
};

export const LIST_AGENCY_OPTION = [
  { label: "Not belong to Agency", value: ENUM_AGENCY.NOT_BELONG_TO_AGENCY },
];

export const LIST_CAMPAIGN_OPTION = [
  {
    label: "Not belong to Campaign",
    value: ENUM_CAMPAIGN.NOT_BELONG_TO_CAMPAIGN,
  },
];

//Campaign
export const LIST_CHANNEL_OPTION = [
  {
    label: "Facebook",
    value: "facebook",
  },
  {
    label: "Google",
    value: "google",
  },
  {
    label: "Tiktok",
    value: "tiktok",
  },
  {
    label: "Offline",
    value: "offline",
  },
];

export const AGENCY_APP_NAME_OPTION = [
  {
    label: "User",
    value: "baive",
  },
  {
    label: "Management",
    value: "baive_manager",
  },
];

export const MANUAL_PUSH_REDIRECT_SCREEN_TARGET = [
  {
    label: "Open App",
    value: "default",
  },

  {
    label: "Open Deep Link",
    value: "open-link",
  },
  {
    label: "Log Bar",
    value: "bar",
  },
  {
    label: "Log Bar Management",
    value: "bar-management",
  },
  {
    label: "Log Wink",
    value: "wink",
  },
  {
    label: "Log News",
    value: "news",
  },
  {
    label: "Log Chat",
    value: "chat",
  },
  {
    label: "Profile",
    value: "profile",
  },
];

export const ENUM_MANUAL_PUSH_SEND_TIME = {
  IMMEDIATELY: "immediately",
  SCHEDULE: "schedule",
};

export const COLOR_MANUAL_PUSH_SEND_TIME: any = {
  [ENUM_MANUAL_PUSH_SEND_TIME.IMMEDIATELY]: "primary",
  [ENUM_MANUAL_PUSH_SEND_TIME.SCHEDULE]: "warning",
};

export const MANUAL_PUSH_SEND_TIME_OPTION = [
  {
    value: ENUM_MANUAL_PUSH_SEND_TIME.IMMEDIATELY,
    label: "Immediately",
  },
  {
    value: ENUM_MANUAL_PUSH_SEND_TIME.SCHEDULE,
    label: "Schedule",
  },
];

export const ENUM_PUSH_LOG_OPEN_STATUS = {
  OPEN: 1,
  NOTOPEN: 0,
};

export const COLOR_OPEN_STATUS: any = {
  [ENUM_PUSH_LOG_OPEN_STATUS.OPEN]: "primary",
  [ENUM_PUSH_LOG_OPEN_STATUS.NOTOPEN]: "danger",
};

export const PUSH_LOG_OPEN_STATUS = [
  {
    value: ENUM_PUSH_LOG_OPEN_STATUS.OPEN,
    label: "Log Open",
  },
  {
    value: ENUM_PUSH_LOG_OPEN_STATUS.NOTOPEN,
    label: "Log Not-Open",
  },
];

export const PUSH_LOG_NOTIFY_TYPE = [
  {
    value: ENUM_NOTIFY_TYPE.AUTO,
    label: "Auto",
  },
  {
    value: ENUM_NOTIFY_TYPE.MANUAL,
    label: "Manual",
  },
];

export const ENUM_PUSH_LOG_PUSH_STATUS = {
  SENT: "sent",
  FAILED: "failed",
  DEACTIVATED: "deactivated",
};

export const COLOR_PUSH_LOG_STATUS = {
  [ENUM_PUSH_LOG_PUSH_STATUS.SENT]: "success",
  [ENUM_PUSH_LOG_PUSH_STATUS.FAILED]: "danger",
  [ENUM_PUSH_LOG_PUSH_STATUS.DEACTIVATED]: "warning",
};

export const PUSH_LOG_PUSH_STATUS = [
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.SENT,
    label: "Sent",
  },
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.FAILED,
    label: "Failed",
  },
  {
    value: ENUM_PUSH_LOG_PUSH_STATUS.DEACTIVATED,
    label: "Sending",
  },
];

export const ENUM_MANUAL_PUSH_STATUS = {
  COMPLETED: "completed",
  INPROGRESS: "processing",
  WAITING: "waiting",
  CANCEL: "cancel",
};

export const COLOR_MANUAL_PUSH_STATUS = {
  [ENUM_MANUAL_PUSH_STATUS.COMPLETED]: "success",
  [ENUM_MANUAL_PUSH_STATUS.INPROGRESS]: "blue",
  [ENUM_MANUAL_PUSH_STATUS.WAITING]: "warning",
  [ENUM_MANUAL_PUSH_STATUS.CANCEL]: "danger",
};

export const MANUAL_PUSH_STATUS = [
  {
    value: ENUM_MANUAL_PUSH_STATUS.COMPLETED,
    label: "Complete",
  },
  {
    value: ENUM_MANUAL_PUSH_STATUS.INPROGRESS,
    label: "Processing",
  },
  {
    value: ENUM_MANUAL_PUSH_STATUS.WAITING,
    label: "Manual Push Waiting",
  },
  {
    value: ENUM_MANUAL_PUSH_STATUS.CANCEL,
    label: "Cancel",
  },
];

// User is guest
export const ENUM_USER_REAL_GUEST = {
  GUEST: "1",
  USER: "0",
};

export const ENUM_GUEST_MODE = {
  GUEST: "1",
  USER: "0",
};

export const COLOR_USER_REAL_GUEST: any = {
  [ENUM_USER_REAL_GUEST.GUEST]: "orange",
  [ENUM_USER_REAL_GUEST.USER]: "success",
};

export const USER_REAL_GUEST_OPTION = [
  { label: "Guest", value: ENUM_USER_REAL_GUEST.GUEST },
  { label: "Normal User", value: ENUM_USER_REAL_GUEST.USER },
];

export const GUEST_MODE_OPTION = [
  { label: "Normal", value: ENUM_GUEST_MODE.USER },
  { label: "Guest", value: ENUM_GUEST_MODE.GUEST },
];

export const LIST_USER_LOG_TYPE_OPTION = [
  { label: "Periodically Updated", value: 1 },
  /* { label: "Sign Up", value: 2 }, */
  { label: "Sign In", value: 3 },
  { label: "Bar List", value: 4 },
  { label: "Wink List", value: 5 },
];

export const LIST_OPTION_SOURCE_APP = [
  {
    label: "App User",
    value: "baive",
  },
  {
    label: "App Management",
    value: "baive_manager",
  },
];

export const LIST_OPTION_MENU = [
  {
    label: "Bar",
    value: "1",
  },
  {
    label: "Bar Manager",
    value: "2",
  },
  {
    label: "Feed",
    value: "3",
  },
  {
    label: "Wink",
    value: "4",
  },
  {
    label: "News",
    value: "5",
  },
  {
    label: "Profile",
    value: "6",
  },
];

export const APP_TYPE_OPTIONS: Option[] = [
  {
    label: "Type User",
    value: "user",
  },
  {
    label: "Type Management",
    value: "manager",
  },
];

// User Type on Log page
export const ENUM_USER_TYPE_LOG = {
  GUEST: "1",
  NORMAL_USER: "2",
  BARTENDER: "3",
  MANAGER: "4",
};

export const COLOR_USER_TYPE_LOG: any = {
  [ENUM_USER_TYPE_LOG.GUEST]: "warning",
  [ENUM_USER_TYPE_LOG.NORMAL_USER]: "success",
  [ENUM_USER_TYPE_LOG.BARTENDER]: "danger",
  [ENUM_USER_TYPE_LOG.MANAGER]: "info",
};

export const USER_TYPE_LOG_OPTION = [
  { label: "Guest", value: ENUM_USER_TYPE_LOG.GUEST },
  { label: "Normal User", value: ENUM_USER_TYPE_LOG.NORMAL_USER },
  { label: "Bartender", value: ENUM_USER_TYPE_LOG.BARTENDER },
  { label: "Label Manager", value: ENUM_USER_TYPE_LOG.MANAGER },
];

export const LIST_CHANNEL_USER_OPTION = [
  {
    label: "Channel Store",
    value: "STORE",
  },
  {
    label: "Channel Agency",
    value: "AGENCY",
  },
  {
    label: "Channel Google",
    value: "GOOGLE",
  },
  {
    label: "Channel Meta",
    value: "META",
  },
];

// event log

export const BAR_SCREEN_CONST = [
  {
    value: "view_detail_bar",
    label: "View Bar Detail",
  },
  {
    value: "search_bar",
    label: "Search Bar",
  },
  {
    value: "view_map_bar",
    label: "View Bar Map",
  },
  {
    value: "my_location_bar",
    label: "Bar Location",
  },
  {
    value: "filter_bar",
    label: "Filter Bar",
  },
  {
    value: "reload_bar",
    label: "Reload Bar",
  },
  {
    value: "view_review_bar",
    label: "View Bar Review",
  },
];

export const BAR_DETAIL_SCREEN_CONST = [
  {
    value: "view_background_photo_bar",
    label: "View Bar Background Photo",
  },
  {
    value: "view_photo_bar",
    label: "View Bar Photo",
  },
  {
    value: "call_bar",
    label: "Call Bar",
  },
  {
    value: "contact_us_bar",
    label: "Bar Contact",
  },
  {
    value: "share_bar",
    label: "Share Bar",
  },
  {
    value: "get_direction_bar",
    label: "Get Bar Direction",
  },
  {
    value: "view_profile_bartender_bar",
    label: "View Bartender Profile",
  },
  {
    value: "view_menu_photo_bar",
    label: "View Bar Menu Photo",
  },
  {
    value: "view_review_bar",
    label: "View Bar Review",
  },
];

export const BAR_MANAGEMENT_SCREEN_CONST = [
  {
    value: "edit_bar",
    label: "Edit Bar",
  },
  {
    value: "coupon_management",
    label: "Coupon Management",
  },
  {
    value: "ads_management",
    label: "Ads Management",
  },
  {
    value: "welcome_message",
    label: "Welcome Message",
  },
  {
    value: "review_management",
    label: "Review Management",
  },
  {
    value: "view_profile_bartender_bar",
    label: "View Bartender Profile",
  },
];

export const BAR_REVIEW_SCREEN_CONST = [
  {
    value: "write_review_bar",
    label: "Write Review",
  },
  {
    value: "edit_review_bar",
    label: "Edit Review",
  },
  {
    value: "delete_review_bar",
    label: "Delete Review",
  },
];

export const WINK_SCREEN_CONST = [
  {
    value: "like_wink",
    label: "Like Wink",
  },
  {
    value: "share_wink",
    label: "Share Wink",
  },
  {
    value: "view_comment_wink",
    label: "View Wink Comment",
  },
  {
    value: "search_wink",
    label: "Search Wink",
  },
  {
    value: "view_photo_wink",
    label: "View Wink Photo",
  },
  {
    value: "connect_user_wink",
    label: "Connect Wink User",
  },
  {
    value: "start_chat",
    label: "Start Chat",
  },
];

export const WINK_DETAIL_SCREEN_CONST = [
  { value: "like_wink", label: "Like Wink" },
  { value: "share_wink", label: "Share Wink" },
  { value: "view_comment_wink", label: "View Wink Comment" },
  { value: "view_photo_wink", label: "View Wink Photo" },
  { value: "connect_user_wink", label: "Connect Wink User" },
  { value: "block_comment_wink", label: "Block Wink Comment" },
  { value: "delete_comment_wink", label: "Delete Wink Comment" },
  { value: "edit_comment_wink", label: "Edit Wink Comment" },
  { value: "write_comment_wink", label: "Write Wink Comment" },
];

export const WINK_COMMENT_SCREEN_CONST = [
  { value: "report_comment_wink", label: "Report Comment" },
  { value: "block_comment_wink", label: "Block Comment" },
  { value: "write_comment_wink", label: "Write Comment" },
  { value: "edit_comment_wink", label: "Edit Comment" },
  { value: "delete_comment_wink", label: "Delete Comment" },
  { value: "view_author_of_comment", label: "View Author Of Comment" },
];

export const NEWS_SCREEN_CONST = [
  { value: "view_news_detail", label: "View Detail" },
  { value: "search_news", label: "Search News" },
];

export const MY_PROFILE_SCREEN_CONST = [
  { value: "coupon_my_profile", label: "Coupon" },
  { value: "qrcode_my_profile", label: "QR" },
  { value: "view_post_my_profile", label: "View My Post" },
  { value: "edit_my_profile", label: "Edit Profile" },
  { value: "like_wink", label: "Like Wink" },
  { value: "view_liked_post_my_profile", label: "View Liked Post" },
  { value: "view_comment_wink", label: "View Wink Comment" },
  { value: "view_photo_wink", label: "View Wink Photo" },
];

export const LIST_POST_MY_PROFILE_SCREEN_CONST = [
  { value: "share_wink", label: "Share Wink" },
];

export const OTHER_PROFILE_SCREEN_CONST = [
  { value: "connect_other_user", label: "Connect Other User" },
  { value: "chat_other_user", label: "Chat Other User" },
  { value: "share_other_user", label: "Share Other User" },
  { value: "block_other_user", label: "Block Other User" },
  { value: "view_comment_wink", label: "View Wink Comment" },
  { value: "view_photo_wink", label: "View Wink Photo" },
  { value: "like_wink", label: "Like Wink" },
  { value: "share_wink", label: "Share Wink" },
];

export const CHAT_SCREEN_CONST = [
  { value: "create_group", label: "Create Group" },
  {
    value: "newest_user|open_user_profile",
    label: "Newest User -> Open Profile",
  },
  {
    value: "newest_user|connect_other_user",
    label: "Newest User -> Connect Other User",
  },
  { value: "conversation|start_chat", label: "Conversation -> Start Chat" },
  { value: "connected_user|start_chat", label: "Connected User -> Start Chat" },
  { value: "newest_user|start_chat", label: "Newst User -> Start Chat" },
  { value: "search_chat", label: "Search Chat" },
];

export const NOTIFICATION_SCREEN_CONST = [
  { value: "open_notification", label: "Open Notification" },
  { value: "open_user_profile", label: "Open User Profile" },
];

export const SETTING_SCREEN_CONST = [
  { value: "account_setting", label: "Account Setting" },
  { value: "change_language", label: "Change Language" },
  { value: "notification", label: "Notification" },
  { value: "blocked_list", label: "Blocked List" },
  { value: "contact_feedback", label: "Contact Feedback" },
  { value: "faq", label: "FAQ" },
  { value: "notice", label: "Notice" },
  { value: "change_language", label: "Change Language" },
  { value: "logout", label: "Logout" },
];

export const SCAN_QR_SCREEN = [
  { value: "shared_link", label: "Shared Link" },
  { value: "shared", label: "Shared" },
  { value: "scan", label: "Scan" },
  { value: "download", label: "Download" },
];

export const SCREEN_CONST = [
  {
    value: "bar_screen",
    label: "Bar",
    children: BAR_SCREEN_CONST,
  },
  {
    value: "bar_review_screen",
    label: "Bar Review",
    children: BAR_REVIEW_SCREEN_CONST,
  },
  {
    value: "bar_detail_screen",
    label: "Bar Detail",
    children: BAR_DETAIL_SCREEN_CONST,
  },
  {
    value: "bar_management_screen",
    label: "Bar Management Screen",
    children: BAR_MANAGEMENT_SCREEN_CONST,
  },
  {
    value: "wink_screen",
    label: "Wink",
    children: WINK_SCREEN_CONST,
  },
  {
    value: "wink_comment_screen",
    label: "Wink Comment",
    children: WINK_COMMENT_SCREEN_CONST,
  },
  {
    value: "wink_detail_screen",
    label: "Wink Detail",
    children: WINK_DETAIL_SCREEN_CONST,
  },
  {
    value: "news_screen",
    label: "News",
    children: NEWS_SCREEN_CONST,
  },
  {
    value: "chat_main_screen",
    label: "Chat",
    children: CHAT_SCREEN_CONST,
  },
  {
    value: "my_account_screen",
    label: "My Profile",
    children: MY_PROFILE_SCREEN_CONST,
  },
  {
    value: "list_post_my_profile",
    label: "List Post My Profile",
    children: LIST_POST_MY_PROFILE_SCREEN_CONST,
  },
  {
    value: "other_user_profile",
    label: "Other's Profile",
    children: OTHER_PROFILE_SCREEN_CONST,
  },
  {
    value: "coupon_screen",
    label: "Coupon",
    children: [],
  },
  {
    value: "scan_qrcode_screen",
    label: "Scan QR",
    children: SCAN_QR_SCREEN,
  },
  {
    value: "notification_screen",
    label: "Notification",
    children: NOTIFICATION_SCREEN_CONST,
  },
  {
    value: "setting_screen",
    label: "Setting",
    children: SETTING_SCREEN_CONST,
  },
  {
    value: "login_screen",
    label: "Login",
    children: [],
  },
];

//end of event log

//start of notification
export const NOTIFICATION_ACTION = [
  { value: "default", label: "Open App" },
  { value: "connect", label: "Connect" },
  { value: "comment", label: "Comment" },
  { value: "message", label: "Message" },
  { value: "home", label: "Home" },
  { value: "search", label: "Search" },
  { value: "explore", label: "Explore" },
  { value: "like", label: "Like" },
  { value: "dislike", label: "Dislike" },
  { value: "bookmark", label: "Bookmark" },
  { value: "unbookmark", label: "Unbookmark" },
  { value: "message-private-chat", label: "Message Private Chat" },
  { value: "message-group-chat", label: "Message Group Chat" },
  { value: "open-link", label: "Open Link" },
  { value: "bar", label: "Notify Bar" },
  { value: "bar-management", label: "Notify Bar Management" },
  { value: "wink", label: "Wink" },
  { value: "news", label: "News" },
  { value: "chat", label: "Chat" },
  { value: "profile", label: "Profile" },
  { value: "share", label: "Shared" },
];

export const ENUM_USER_TYPE_BAR = {
  NORMAL_USER: 1,
  BARTENDER: 2,
  MANAGER: 3,
};

export const COLOR_USER_TYPE_BAR: any = {
  [ENUM_USER_TYPE_BAR.NORMAL_USER]: "success",
  [ENUM_USER_TYPE_BAR.BARTENDER]: "danger",
  [ENUM_USER_TYPE_BAR.MANAGER]: "info",
};

export const USER_TYPE_BAR_OPTION = [
  { label: "Normal User", value: ENUM_USER_TYPE_BAR.NORMAL_USER },
  { label: "Bartender", value: ENUM_USER_TYPE_BAR.BARTENDER },
  { label: "Label Manager", value: ENUM_USER_TYPE_BAR.MANAGER },
];

//hashtag
export const ENUM_HASHTAG_STATUS = {
  ACTIVATED: 1,
  INACTIVATED: 0,
};

export const COLOR_HASHTAG_STATUS: any = {
  [ENUM_HASHTAG_STATUS.ACTIVATED]: "success",
  [ENUM_HASHTAG_STATUS.INACTIVATED]: "danger",
};

export const HASHTAG_STATUS_OPTION = [
  { label: "Active", value: ENUM_HASHTAG_STATUS.ACTIVATED },
  { label: "InActive", value: ENUM_HASHTAG_STATUS.INACTIVATED },
];

export const AGENCY_CUSTOM_PARAM_CHANNEL_OPTION = [
  {
    label: "Google Ads Tracking",
    value: "google",
  },
  {
    label: "Meta Ads tracking",
    value: "meta",
  },
];

//Send push
export const ENUM_MANUAL_PUSH_SAVE_OPTION = {
  SAVE: 1,
  NOT_SAVE: 0,
};

export const COLOR_MANUAL_PUSH_SAVE_OPTION: any = {
  [ENUM_MANUAL_PUSH_SAVE_OPTION.SAVE]: "primary",
  [ENUM_MANUAL_PUSH_SAVE_OPTION.NOT_SAVE]: "warning",
};

export const MANUAL_PUSH_SAVE_OPTION = [
  {
    value: ENUM_MANUAL_PUSH_SAVE_OPTION.SAVE,
    label: "Save",
  },
  {
    value: ENUM_MANUAL_PUSH_SAVE_OPTION.NOT_SAVE,
    label: "Not-save",
  },
];

export const USER_NOTIFICATION_ALLOW_TYPE_OPTION = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Connect",
    value: "connect",
  },
  {
    label: "Comment",
    value: "comment",
  },
  {
    label: "Message",
    value: "message",
  },
  {
    label: "Like",
    value: "like",
  },
  {
    label: "Share",
    value: "share",
  },
  {
    label: "Promotion Event",
    value: "promotion_event",
  },
  {
    label: "Inquiry",
    value: "inquiry",
  },
];

export const STATUS_APPLICATION_OPTION = [
  {
    label: "Pending",
    value: ENUM_STATUS_APPLICATION.PENDING,
  },
  {
    label: "InReview",
    value: ENUM_STATUS_APPLICATION.IN_REVIEW,
  },
  {
    label: "Resulted",
    value: ENUM_STATUS_APPLICATION.RESULTED,
  },
];

export const ENUM_AUDITION_STATUS = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  // EXPIRED: "EXPIRED",
  CLOSED: "CLOSED",
};

export const COLOR_AUDITION_STATUS: any = {
  [ENUM_AUDITION_STATUS.DRAFT]: "warning",
  [ENUM_AUDITION_STATUS.PUBLISHED]: "primary",
  // [ENUM_AUDITION_STATUS.EXPIRED]: "success",
  [ENUM_AUDITION_STATUS.CLOSED]: "danger",
};

export const LIST_OPTION_AUDITION_STATUS = [
  {
    label: "Draft",
    value: ENUM_AUDITION_STATUS.DRAFT,
  },
  {
    label: "Published",
    value: ENUM_AUDITION_STATUS.PUBLISHED,
  },
  // {
  //   label: "Expired",
  //   value: ENUM_AUDITION_STATUS.EXPIRED,
  // },
  {
    label: "Closed",
    value: ENUM_AUDITION_STATUS.CLOSED,
  },
];

export const ENUM_APPLICATION_STATUS = {
  APPLIED: "APPLIED",
  SCREENING_PASSED: "SCREENING_PASSED",
  SCREENING_FAILED: "SCREENING_FAILED",
  AUDITION_SCHEDULED: "AUDITION_SCHEDULED",
  AUDITION_COMPLETED: "AUDITION_COMPLETED",
  FINAL_PASSED: "FINAL_PASSED",
  REJECTED: "REJECTED",
  USER_CANCELED: "USER_CANCELED",
};

export const COLOR_APPLICATION_STATUS: any = {
  [ENUM_APPLICATION_STATUS.APPLIED]: "primary",
  [ENUM_APPLICATION_STATUS.SCREENING_PASSED]: "warning",
  [ENUM_APPLICATION_STATUS.SCREENING_FAILED]: "danger",
  [ENUM_APPLICATION_STATUS.AUDITION_SCHEDULED]: "info",
  [ENUM_APPLICATION_STATUS.AUDITION_COMPLETED]: "secondary",
  [ENUM_APPLICATION_STATUS.FINAL_PASSED]: "success",
  [ENUM_APPLICATION_STATUS.REJECTED]: "danger",
  [ENUM_APPLICATION_STATUS.USER_CANCELED]: "dark",
};

export const LIST_OPTION_APPLICATION_STATUS = [
  {
    label: "Applied",
    value: ENUM_APPLICATION_STATUS.APPLIED,
  },
  {
    label: "Screening Passed",
    value: ENUM_APPLICATION_STATUS.SCREENING_PASSED,
  },
  {
    label: "Screening Failed",
    value: ENUM_APPLICATION_STATUS.SCREENING_FAILED,
  },
  {
    label: "Audition Scheduled",
    value: ENUM_APPLICATION_STATUS.AUDITION_SCHEDULED,
  },
  {
    label: "Audition Completed",
    value: ENUM_APPLICATION_STATUS.AUDITION_COMPLETED,
  },
  {
    label: "Final Passed",
    value: ENUM_APPLICATION_STATUS.FINAL_PASSED,
  },
  {
    label: "Rejected",
    value: ENUM_APPLICATION_STATUS.REJECTED,
  },
  {
    label: "User Canceled",
    value: ENUM_APPLICATION_STATUS.USER_CANCELED,
  },
];

export const ENUM_PHONE_TYPE = {
  WORKING: "working",
};

export const COLOR_PHONE_TYPE: any = {
  [ENUM_PHONE_TYPE.WORKING]: "primary",
};

export const LIST_OPTION_PHONE_TYPE = [
  {
    label: "Working",
    value: ENUM_PHONE_TYPE.WORKING,
  },
];

export const LIST_OPTION_SNS_TYPE = [
  {
    label: "Instagram",
    value: "INSTAGRAM",
  },
  {
    label: "YouTube",
    value: "YOUTUBE",
  },
  {
    label: "Facebook",
    value: "FACEBOOK",
  },
  {
    label: "Tiktok",
    value: "TIKTOK",
  },
  {
    label: "X",
    value: "X",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];

export const ENUM_MILITARY_STATUS = {
  COMPLETED: "COMPLETED",
  NOT_COMPLETED: "NOT_COMPLETED",
};

export const COLOR_MILITARY_STATUS: any = {
  [ENUM_MILITARY_STATUS.COMPLETED]: "primary",
  [ENUM_MILITARY_STATUS.NOT_COMPLETED]: "danger",
};

export const LIST_OPTION_MILITARY_STATUS = [
  {
    label: "Completed",
    value: ENUM_MILITARY_STATUS.COMPLETED,
  },
  {
    label: "Not Completed",
    value: ENUM_MILITARY_STATUS.NOT_COMPLETED,
  },
];

export const LIST_OPTION_VOICE_RANGE = [
  {
    label: "Private",
    value: "PRIVATE",
  },
  {
    label: "Soprano",
    value: "SOPRANO",
  },
  {
    label: "Mezzo Soprano",
    value: "MEZZO_SOPRANO",
  },
  {
    label: "Alto",
    value: "ALTO",
  },
  {
    label: "Baritone",
    value: "BARITONE",
  },
  {
    label: "Bass",
    value: "BASS",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];

export const ENUM_USER_TYPE = {
  GUEST: "guest",
  NORMAL_USER: "normal",
};

export const COLOR_USER_TYPE: any = {
  [ENUM_USER_TYPE.GUEST]: "warning",
  [ENUM_USER_TYPE.NORMAL_USER]: "success",
};

export const LIST_OPTION_USER_TYPE = [
  { label: "Guest", value: ENUM_USER_TYPE.GUEST },
  { label: "Normal User", value: ENUM_USER_TYPE.NORMAL_USER },
];

export const ENUM_USER_ACCOUNT_TYPE = {
  BUSINESS: "BUSINESS",
  ARTIST: "ARTIST",
};

export const COLOR_USER_ACCOUNT_TYPE: any = {
  [ENUM_USER_ACCOUNT_TYPE.BUSINESS]: "primary",
  [ENUM_USER_ACCOUNT_TYPE.ARTIST]: "danger",
};

export const LIST_OPTION_USER_ACCOUNT_TYPE = [
  { label: "Business", value: ENUM_USER_ACCOUNT_TYPE.BUSINESS },
  { label: "Artist", value: ENUM_USER_ACCOUNT_TYPE.ARTIST },
];

export const LIST_OPERATOR_ROLE_OPTION = [
  {
    label: "Role_Admin",
    value: "ADMIN",
  },
  {
    label: "Role_Company",
    value: "COMPANY",
  },
];

export const INQUIRY_TYPE = [
  {
    label: "Report Bug",
    value: 1,
  },
  {
    label: "Account Issue",
    value: 2,
  },
  {
    label: "Service Inquiry",
    value: 3,
  },
  {
    label: "Payment Refund",
    value: 4,
  },
  {
    label: "Complaint",
    value: 5,
  },
];

export const COLOR_INQUIRY_TYPE: any = {
  [1]: "danger",
  [2]: "secondary",
  [3]: "success",
  [4]: "primary",
  [5]: "warning",
};

export const INQUIRY_STATUS = [
  {
    label: "Inquiry_PENDING",
    value: 1,
  },
  {
    label: "Inquiry_IN_PROGRESS",
    value: 2,
  },
  {
    label: "Inquiry_RESOLVED",
    value: 3,
  },
  {
    label: "Inquiry_CLOSED",
    value: 4,
  },
];

export const COLOR_INQUIRY_STATUS: any = {
  [1]: "warning",
  [2]: "primary",
  [3]: "success",
  [4]: "danger",
};

export const HEXCOLOR_INQUIRY_STATUS: any = {
  [1]: "#ffc107",
  [2]: "#007bff",
  [3]: "#28a745",
  [4]: "#dc3545",
};

export const INQUIRY_REPLY_TYPE = [
  {
    label: "User",
    value: 1,
  },
  {
    label: "Admin",
    value: 2,
  },
];

export const INQUIRY_ATTACHMENT_TYPE = [
  {
    label: "Pending",
    value: 1,
  },
  {
    label: "In-Progress",
    value: 2,
  },
  {
    label: "Resolved",
    value: 3,
  },
];

const ENUM_CATEGORY_STATUS = {
  ACTIVATED: 1,
  DEACTIVATED: 0,
};

export const CATEGORY_STATUS = [
  {
    label: "Activated",
    value: ENUM_CATEGORY_STATUS.ACTIVATED,
  },
  {
    label: "Deactivated",
    value: ENUM_CATEGORY_STATUS.DEACTIVATED,
  },
];

export const COLOR_CATEGORY_STATUS = {
  [ENUM_CATEGORY_STATUS.ACTIVATED]: "success",
  [ENUM_CATEGORY_STATUS.DEACTIVATED]: "danger",
};
